import { Component, EventEmitter, Input, Output } from '@angular/core';
import {
  AuthenticationActionType,
  ForgotSendMailRequest,
  ForgotStep,
  ForgotUpdatePasswordRequest,
  SignAction
} from '@pt/pt-models';


@Component({
  selector: 'pt-forgot-password',
  templateUrl: './forgot-password.component.html'
})
export class ForgotPasswordComponent {
  // Header
  @Input() title?: string;
  @Input() subtitle?: string;
  @Input() logo?: string;
  @Input() closeLabel!: string;
  @Input() errorMessage: string;
  @Input() completeMessage: string;

  // Generic
  @Input() step!: ForgotStep;
  @Input() confirmLabel!: string;
  @Input() cancelLabel!: string;
  @Input() loading: boolean;
  @Input() domain: string;
  @Input() email: string;

  // Step 1: Invio Email
  @Input() domainLabel!: string;
  @Input() emailLabel!: string;

  // Step 2: Cambio Password
  @Input() tokenLabel!: string;
  @Input() passwordLabel!: string;
  @Input() confirmPasswordLabel!: string;

  @Output() forgotPasswordAction = new EventEmitter<SignAction & { rcToken?: string }>();

  public ForgotStep = ForgotStep;

  // private recaptchaSub$;

  // constructor(private recaptchaV3Service: ReCaptchaV3Service) {}

  onCancel() {
    this.forgotPasswordAction.emit({action: AuthenticationActionType.CANCEL} as SignAction);
  }

  onConfirmSendMail(payload: ForgotSendMailRequest) {
    const rcToken = '';
    const signAction: SignAction & { rcToken: string } = {
      action: AuthenticationActionType.FORGOT_SEND_EMAIL, payload, rcToken
    }
    this.forgotPasswordAction.emit(signAction);

    // this.recaptchaSub$ = this.recaptchaV3Service.execute('sendMail'
    // ).subscribe((token) => {
    //   const rcToken = token;
    //   const signAction: SignAction & { rcToken: string } = {
    //     action: AuthenticationActionType.FORGOT_SEND_EMAIL, payload, rcToken
    //   }
    //   this.forgotPasswordAction.emit(signAction);
    // });
  }

  onConfirmUpdatePassword(payload: ForgotUpdatePasswordRequest) {
    const rcToken = '';
    const signAction: SignAction & { rcToken: string } = {
      action: AuthenticationActionType.FORGOT_UPDATE_PASSWORD, payload, rcToken
    }
    this.forgotPasswordAction.emit(signAction);

    // this.recaptchaSub$ = this.recaptchaV3Service.execute('updatePassword'
    // ).subscribe((token) => {
    //   const rcToken = token;
    //   const signAction: SignAction & { rcToken: string } = {
    //     action: AuthenticationActionType.FORGOT_UPDATE_PASSWORD, payload, rcToken
    //   }
    //   this.forgotPasswordAction.emit(signAction);
    // });
  }
}
